import { useState } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Button } from '@mui/material';
import Download from '@mui/icons-material/Download';
import { ChartType } from "components/charts/types";

const menuContainerStyle = {
  position: 'absolute' as const,
  top: '20px',
  right: '32px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'white',
  cursor: 'pointer'
};

const dotsContainerStyle = {
  display: 'flex',
  flexDirection: 'column' as const,
  gap: '3px',
  padding: '8px',
};

const dotStyle = {
  width: '3px',
  height: '3px',
  background: '#666666',
  borderRadius: '9999px',
};

const dropdownStyle = {
  position: 'absolute' as const,
  display: 'flex',
  flexDirection: 'column' as const,
  right: '100%',
  top: 0,
  width: '175px',
  backgroundColor: 'white',
  borderRadius: '10px',
  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
  zIndex: 10000,
};

const buttonBaseStyle = {
  width: '100%',
  color: 'black',
  backgroundColor: 'white',
  textTransform: 'none',
  justifyContent: 'left',
  ':hover': {
    backgroundColor: '#E5E8EC'
  }
};

type ChartMenuProps = {
  chartRef: React.RefObject<HTMLDivElement>,
  fileName: ChartType
};

const ChartMenu = ({ chartRef, fileName }: ChartMenuProps) => {
  const [isHovering, setIsHovering] = useState(false);

  const handlePNGDownload = () => {
    if (!chartRef?.current) return;

    html2canvas(chartRef.current).then((canvas: HTMLCanvasElement) => {
      const link = document.createElement('a');
      link.download = `${fileName}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    });
  };

  const handlePDFDownload = () => {
    if (!chartRef?.current) return;

    html2canvas(chartRef.current).then((canvas: HTMLCanvasElement) => {
      const imgWidth = 200;
      const imgHeight = (canvas.height / canvas.width) * imgWidth;
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight, '', 'NONE', 0);
      pdf.save(`${fileName}.pdf`);
    });
  };

  return (
    <div
      style={menuContainerStyle}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <div style={dotsContainerStyle}>
        <div style={dotStyle} />
        <div style={dotStyle} />
        <div style={dotStyle} />
      </div>

      {isHovering && (
        <div style={dropdownStyle}>
          <>
            <Button
              onClick={handlePNGDownload}
              variant='contained'
              startIcon={<Download />}
              sx={{
                ...buttonBaseStyle,
                borderRadius: '10px 10px 0 0',
              }}
            >
              Download as PNG
            </Button>

            <Button
              onClick={handlePDFDownload}
              variant='contained'
              startIcon={<Download />}
              sx={{
                ...buttonBaseStyle,
                borderRadius: '0 0 10px 10px',
              }}
            >
              Download as PDF
            </Button>
          </>
        </div>
      )}
    </div>
  );
};

export default ChartMenu;
